export default function getUserToken() {
  const token = localStorage.getItem("user");
  //Tirando aspa da string do token
  const tokenJWT = token?.replace(/^['"]|['"]$/g, '');

  return tokenJWT;
}
